import { render, staticRenderFns } from "./PublicWeddingEvent.vue?vue&type=template&id=1d93451a&scoped=true"
import script from "./PublicWeddingEvent.vue?vue&type=script&lang=ts"
export * from "./PublicWeddingEvent.vue?vue&type=script&lang=ts"
import style0 from "./PublicWeddingEvent.vue?vue&type=style&index=0&id=1d93451a&prod&lang=css"
import style1 from "./PublicWeddingEvent.vue?vue&type=style&index=1&id=1d93451a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93451a",
  null
  
)

export default component.exports